export default __webpack_public_path__ + "static/media/kemmi.4a316969.png";